<script setup lang="ts">
import OHeader from '~/components/organisms/TheHeader.vue'
import RFooter from '~/components/organs/Footer.vue'
import RAlert from '~/components/organs/CookiesAlert.vue'

useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
  ],
})

</script>

<template>
  <div class="wrapper">
    <OHeader :is-editor="false" />
    <main>
      <slot />
    </main>
    <RFooter />
    <RAlert />
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow-x: hidden;

  main {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;

    .btn-improvement {
      border: none;
      padding: 0;
      background: $color-grey;
      border-radius: rem(4px) rem(4px) 0 0;
      height: rem(29px);
      width: rem(142px);
      font-size: rem(14px);
      font-weight: 400;
      line-height: rem(21px);
      position: fixed;
      top: calc(50% - 57px);
      right: rem(29px);
      transform: translateY(-50%) rotate(-90deg);
      transform-origin: top right;
      transition: .3s ease;

      &:hover {
        background: $indigo;
        color: $white;
      }
    }
  }

}
</style>
